<template>
  <div
    :class="{
      'card': true,
      'is-smallshadow': true,
      'complete': isFormComplete
    }">
    <div
      :class="{
        'card-body': true,
        'width-narrow': !readonly,
        'form-readonly': readonly
      }">
      <h2
        :class="{
          'heading-bigger mb-4': !readonly,
          'heading-small text-grey': readonly
        }">
        {{ $t('inquiryForm.householdInfo') }}
      </h2>

      <div class="form-group">
        <label class="wide" for="flatmate-count">{{ $t('inquiryHouseholdInfo.numberOfPeopleOnHousehold') }}</label>

        <template v-if="!readonly">
          <validation-provider
            rules="required|min_value:1"
            name="flatmate-count"
            v-slot="{ errors }">
            <f-input
              min="1"
              step="1"
              type="number"
              v-model="data.flatmate_count"
              :state="errors.length ? 'invalid' : null"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </template>
        <template v-else>
          {{ data.flatmate_count }}
        </template>
      </div>

      <div class="form-group">
        <label class="wide" for="credit-recipient-age">{{ $t('inquiryHouseholdInfo.ageOfOldestBorrower') }}</label>

        <template v-if="!readonly">
          <validation-provider
            name="credit-recipient-age"
            rules="required|min_value:18"
            v-slot="{ errors }">
            <f-input
              type="number"
              v-model="data.credit_recipient_age"
              :state="errors.length ? 'invalid' : null"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </template>
        <template v-else>
          {{ data.credit_recipient_age }}
        </template>
      </div>

      <div class="form-group">
        <label class="wide" for="household-additional-information">{{ $t('inquiryHouseholdInfo.additionalInfo') }}</label>

        <template v-if="!readonly">
          <validation-provider
            name="household-additional-informationn"
            v-slot="{ errors }">
            <f-textarea
              v-model="data.household_additional_information"
              :rows="6"
              :state="errors.length ? 'invalid' : null"/>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </template>
        <template v-else>
          <template v-if="data.household_additional_information && data.household_additional_information.length">
            {{ data.household_additional_information }}
          </template>
          <template v-else>
            -
          </template>
        </template>
      </div>

    </div>

    <div
      v-if="!readonly"
      class="card-footer pt-3 pb-4 text-right">
      <f-button
        theme="primary"
        withArrow
        big
        @click.prevent="goToNextTab">
        {{ $t('ui.next') }}
      </f-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'inquiry-household-info-form',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isValid: {
      type: Boolean,
      default: false
    },
    flatmate_count: {
      type: Number,
      default: 1
    },
    credit_recipient_age: {
      type: Number,
      default: 0
    },
    household_additional_information: {
      type: String,
      required: false
    }
  },
  computed: {
    isFormComplete() {
      let isComplete = !!this.data.flatmate_count && !!this.data.credit_recipient_age;

      isComplete = isComplete && this.isValid;
      if (this.loaded && (isComplete !== this.previousIsCompleteSet)) {
        Vue.set(this, 'previousIsCompleteSet', isComplete);
        this.$bus.$emit('inquiry-form-part-complete', this.index, isComplete, 'household-info');
      }

      return isComplete;
    },
  },
  data() {
    return {
      data: {
        flatmate_count: 1,
        credit_recipient_age: 0,
        household_additional_information: ''
      },
      loaded: false,
      previousIsCompleteSet: false
    };
  },
  mounted () {
    Vue.nextTick(() => {
      Vue.set(this.data, 'flatmate_count', this.flatmate_count);
      Vue.set(this.data, 'credit_recipient_age', this.credit_recipient_age);
      Vue.set(this.data, 'household_additional_information', this.household_additional_information);

      this.loaded = true;

      if (this.isEdit && this.readonly) {
        this.$bus.$emit('inquiry-form-part-complete', this.index, true, 'household-info');
      }
    });
  },
  methods: {
    goToNextTab () {
      this.$bus.$emit('inquiry-form-go-next-tab', this.index + 1);
    },
    getData () {
      return {
        flatmate_count: this.data.flatmate_count,
        credit_recipient_age: this.data.credit_recipient_age,
        household_additional_information: this.data.household_additional_information
      };
    }
  }
}
</script>
